window.MobileModals = (tab) => {
	return {
		activeTab: tab,
	
		activateTab (title, isOpen) {
			if (title == this.activeTab) {
				return !isOpen;
			}
			this.activeTab = title;

            console.log(this.activeTab);

			return true;
		},
	};
}